import React from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

const SummaryStatsCard = ({ summary }) => {
  if (!summary) return null;

  return (
    <Paper
      elevation={1}
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        py: 1.5,
        my: 1,
        backgroundColor: "#f0f9f5",
        border: "1px solid #cce3d3",
        borderRadius: 2,
        fontSize: "0.9rem",
      }}
    >
      <Typography variant="body2">
        🎯 <strong>{summary.given}</strong> / {summary.total} Awards Given
      </Typography>
      <Typography variant="body2">
        💰 <strong>${summary.amountGiven.toLocaleString()}</strong> / $
        {summary.amountTotal.toLocaleString()}
      </Typography>
      <Typography variant="body2">
        🔢 <strong>{summary.remaining}</strong> Awards Remaining
      </Typography>
      <Typography variant="body2">
        📉 <strong>${summary.amountRemaining.toLocaleString()}</strong>{" "}
        Remaining
      </Typography>
    </Paper>
  );
};

export default SummaryStatsCard;
